import React from "react";
import ServiceTrackPage from "./ServiceTrackPage";

const voiceAIPhases = [
  {
    step: "01",
    title: "Use Case & Call Flow Mapping",
    detail:
      "We audit your inbound and outbound call workflows, identify volume patterns, and define agent scope, escalation triggers, and success criteria.",
  },
  {
    step: "02",
    title: "Voice Agent Design",
    detail:
      "We design the conversation architecture, intent handling, emotional calibration, and tone guidelines tailored to your specific use case and audience.",
  },
  {
    step: "03",
    title: "Build & Integration",
    detail:
      "We build, test, and integrate the voice agent into your telephony stack with monitoring, call logging, and quality scoring from day one.",
  },
  {
    step: "04",
    title: "Launch & Optimize",
    detail:
      "We go live, monitor call quality and completion rates, and continuously tune the agent against real conversation data and business outcomes.",
  },
];

const VoiceAIPage = () => {
  return (
    <ServiceTrackPage
      trackLabel="Voice AI Track"
      title="Voice AI That Thinks Before It Speaks"
      accentLine="Intelligent conversations at any scale."
      description="Intelligent voice agents that conduct real conversations — inbound and outbound — across any language, market, and volume. Built for accuracy, natural tone, emotional awareness, and low latency response that keeps conversations flowing."
      topPrimaryCtaLabel="Book a Voice AI Session"
      topSecondaryCtaLabel="See Execution Model"
      engagementId="voice-ai-delivery"
      outcomesHeading="What You Walk Away With"
      outcomes={[
        "Production voice agent deployed across inbound or outbound call flows",
        "Multilingual and multi-accent support with sub-second response latency",
        "Emotional awareness and tone calibration built in from the start",
        "Full observability with call logs, quality scores, and performance reporting",
      ]}
      metricsHeading="Expected Outcomes"
      metrics={[
        { value: "<1s", label: "response latency target" },
        { value: "95%+", label: "call completion target" },
        { value: "24/7", label: "operational uptime" },
        { value: "Multi", label: "language and accent support" },
      ]}
      phases={voiceAIPhases}
      finalEyebrow="Final Step"
      finalTitleLine="Start with one high-impact call flow."
      finalAccentLine="We'll build an agent that sounds like your best operator."
      finalDescription="Launch with a focused voice AI sprint targeting one inbound or outbound use case — then scale the same architecture across channels and markets."
      finalCtaLabel="Book a Free Audit"
    />
  );
};

export default VoiceAIPage;
